import Handlebars from '@sparta.global.vendors/handlebars';
import { requiredAttrsCheck, removeReservedAttrs, combineAttrs, buildAttrsString } from '@sparta.global.helpers/utils-helper/dist/es5.js';

// The module to be exported.
function datepicker(data, returnRawHtml) {
  var requiredAttrs = ['id'];
  var reservedAttrs = ['type', 'data-mask', 'data-gis-mask'];
  var inline = !!data.datepicker.inline;
  var calendarSkin = data.datepicker.skin || 'default-design';
  var combinableAttrs = {
    class: "datepicker".concat(inline ? '' : ' spa-input-text'),
    value: '',
    autocomplete: 'off'
  };
  var applyGisMask = data.datepicker['gis-mask'];
  var validationRules = data.validationRules;
  if (typeof applyGisMask !== 'undefined') {
    // eslint-disable-next-line no-param-reassign
    data.input.attrs['data-field-type'] = applyGisMask;
    combinableAttrs.class = "".concat(combinableAttrs.class, " gis-mask");
  }
  if (!requiredAttrsCheck(data.datepicker.attrs, requiredAttrs).pass) {
    // Server-side only.
    var _requiredAttrsCheck = requiredAttrsCheck(data.datepicker.attrs, requiredAttrs),
      missingField = _requiredAttrsCheck.missingField;
    global.nodeModules.grunt.fail.fatal("You are missing the required attribute ".concat(missingField));
  }
  removeReservedAttrs(data.datepicker.attrs, reservedAttrs);
  combineAttrs(data.datepicker.attrs, combinableAttrs);
  var attrsStr = buildAttrsString(data.datepicker.attrs);
  var containerClasses = "\n    spa-input\n    spa-input--sparta2\n    spa-input-box\n    spa-date-input\n    spa-date-input--".concat(calendarSkin, "\n    spa-input--").concat(data.skin || 'material-design', "\n    ").concat(data.containerClasses ? data.containerClasses.join(' ') : '', "\n    ").concat(data.datepicker.attrs['data-help-body'] ? 'has-help' : '', "\n  ");

  // Help Icon integration.
  var helpToggleText = '';
  if (data.helpToggle) {
    helpToggleText = data.helpToggle;
  } else if (data.label) {
    helpToggleText = data.label.text;
  }
  var helpIconStyles = ['datepicker-icon-box', 'ui-datepicker-trigger'];
  var helpMarkup = '';
  var helpIconLabel = function helpIconLabel(attr) {
    var helpContainerMarkup = '';
    if (!attr['data-help-body']) {
      return '';
    }
    helpIconStyles.push('toggle-trigger-help');
    var markup = "\n      <span class=\"toggle-trigger-box\">\n        <button\n          type=\"button\"\n          id=\"help-open-".concat(data.datepicker.attrs.id, "\"\n          aria-label=\"").concat(helpToggleText, "\"\n          class=\"toggle-trigger svg-button svg-button-help\"\n        ></button>\n      </span>\n    ");
    var helpContainer = "\n      <div\n        class=\"input-help\"\n        id=\"helpLayer_".concat(data.datepicker.attrs.id, "\"\n        role=\"tooltip\"\n        aria-hidden=\"true\"\n      >\n    ");
    var helpClose = "\n      <button\n        type=\"button\"\n        id=\"help-close-".concat(data.datepicker.attrs.id, "\"\n        aria-label=\"").concat(helpToggleText, "\"\n        class=\"close-trigger svg-button\"\n      >&nbsp;</button>\n    ");
    var helpBody = "<div class=\"body\">".concat(data.datepicker.attrs['data-help-body'], "</div>");
    if (data.datepicker.attrs['data-help-head']) {
      helpBody = "<div class='head'>".concat(data.datepicker.attrs['data-help-head'], "</div>").concat(helpBody);
    }
    helpContainerMarkup = "".concat(markup).concat(helpContainer).concat(helpClose).concat(helpBody, "</div>");
    return helpContainerMarkup;
  };
  helpMarkup = helpIconLabel(data.datepicker.attrs);

  // If required, show the asterisk.
  var inputLabelRequiredSpan = function inputLabelRequiredSpan(required) {
    return required ? '<span class="spa-input-label--asterisk">&nbsp;*</span>' : '';
  };
  var datepickerStyles = ['datepicker-icon--calendar'];
  if (data.datepicker.attrs.disabled) {
    datepickerStyles.push('datepicker-icon--calendar__disabled');
  }
  var output;
  if (inline) {
    output = "\n      <div class=\"".concat(containerClasses, "\" ").concat(data.required ? 'required aria-required="true"' : '', ">\n        <div ").concat(attrsStr, "></div>\n      </div>\n    ");
  } else {
    var validationRulesAttr = '';
    if (validationRules) {
      var rules = JSON.stringify(validationRules).replace(/'/g, '&#39;');
      validationRulesAttr = "data-validation-rules='".concat(rules, "'");
    }
    var labelText = "".concat(data.label.text).concat(inputLabelRequiredSpan(data.required, data.asterisk));
    if (data.label.adaText) {
      labelText = "".concat(labelText, " <span class=\"ada-hidden\">").concat(data.label.adaText, "</span>");
    }
    output = "\n      <div\n        class=\"".concat(containerClasses, " ").concat(data.datepicker.attrs.value ? '' : 'spa-input--empty', "\"\n        data-calendar-skin=\"").concat(calendarSkin, "\"\n      >\n        <label class=\"spa-input-label\" for=\"").concat(data.datepicker.attrs.id, "\">").concat(labelText, "</label>\n        <input\n          type=\"text\"\n          aria-describedby=\"").concat(data.datepicker.attrs.id, "_errorMessage ").concat(data.datepicker.attrs.id, "-hint-text\"\n          ").concat(attrsStr, "\n          ").concat(data.vueOptionsStr || '', "\n          ").concat(validationRulesAttr, "\n          ").concat(data.required ? "required aria-required=\"true\" ".concat(typeof data.required === 'string' ? "data-required-error-message=\"".concat(data.required, "\"") : '') : '', "\n        />\n        <button\n          type=\"button\"\n          class=\"").concat(helpIconStyles.join(' '), "\"\n          aria-label=\"").concat(data.label.text, "\"\n          aria-controls=\"ui-datepicker-div\"\n          aria-expanded=\"false\"\n        ><i\n          for=\"").concat(data.datepicker.attrs.id, "\"\n          class=\"").concat(datepickerStyles.join(' '), "\"\n        ></i></button>\n        ").concat(helpMarkup, "\n        <p id=\"").concat(data.datepicker.attrs.id, "-hint-text\" class=\"spa-input-hint\">").concat(data.hintText || '', "</p>\n        <div\n          id=\"").concat(data.datepicker.attrs.id, "_errorMessage\"\n          class=\"spa-input-error-message spa-icon--error\"\n          aria-hidden=\"true\"\n        ></div>\n      </div>\n    ");
  }
  return returnRawHtml === true ? output : new Handlebars.SafeString(output);
}
datepicker.functionName = "datepicker";
export { datepicker };